export default __webpack_public_path__ + "static/media/eduNavy.5fda2aeb.svg";